export const saveDataToLocalStorage = (key: string, data: string): void => {
  window.localStorage.setItem(key, data);
};

export const getDataFromLocalStorage = (key: string): string | null => {
  return window.localStorage.getItem(key);
};

export const removeFromLocalStorage = (key: string): void => {
  window.localStorage.removeItem(key);
};
